import { createUserFunction, FirebaseAuthentication } from 'services/firebase';

const createAccount = async (email, password, firstName, lastName) => {
  await createUserFunction({
    email,
    password,
    firstName,
    lastName,
  });

  await FirebaseAuthentication().signInWithEmailAndPassword(email, password);

  await FirebaseAuthentication().currentUser.sendEmailVerification();
};

export default createAccount;
